import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/plat/admin/track/analyse/"

function baseApi() {

    function activeUser(data) {
        return Post(baseUrl + "activeUser", data)
    }

    function newUser(data) {
        return Post(baseUrl + "newUser", data)
    }

    function retention(data) {
        return Post(baseUrl + "retention", data)
    }

    function summary(data) {
        return Post(baseUrl + "summary", data)
    }

    function queryActiveUserByTimeInterval(data) {
        return Post(baseUrl + "queryActiveUserByTimeInterval", data)
    }

    function queryNewUserByTimeInterval(data) {
        return Post(baseUrl + "queryNewUserByTimeInterval", data)
    }

    function queryRetentionUserByTimeInterval(data) {
        return Post(baseUrl + "queryRetentionUserByTimeInterval", data)
    }


    return {
        activeUser,
        newUser,
        retention,
        summary,
        queryActiveUserByTimeInterval,
        queryRetentionUserByTimeInterval,
        queryNewUserByTimeInterval
    }
}

export const trackAnalyseApi = baseApi()